var mentions_default = {
  "mentionPalette": "_8YJK8",
  "mention": "xRAdJ",
  "mentionViewer": "HdXk6",
  "mentionSuggestionsEntry": "PQAxr",
  "mentionSuggestionsEntryFocused": "nffnE",
  "mentionSuggestionsEntryText": "oudJt",
  "mentionSuggestionsEntryAvatar": "H60vm",
  "mentionSuggestions": "zcTku",
  "cursorDefault": "gEfTp",
  "cursorPointer": "Zgk6H"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
